const fonts = {
  light: 'Poppins-Light',
  regular: 'Poppins-Regular',
  medium: 'Poppins-Medium',
  semiBold: 'Poppins-Bold',
  bold: 'Poppins-Bold',
};
export default fonts;
